import { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import './RegisteredUsers.css';

const View = ({ data, actionBodyTemplate, first, rows, paginatorTemplate, onCustomPage }) => {
    return (
        <div>
            <div className='userTabHeader'>Registered User</div>
            <div>
                <DataTable value={data} responsiveLayout="scroll" className="registered-users"
                    paginator paginatorTemplate={paginatorTemplate} first={first} rows={rows} onPage={onCustomPage}
                    paginatorClassName="justify-content-end">
                    <Column field='name' header='Name' className="text-[#179ab7]"></Column>
                    <Column field='email' header='Email'></Column>
                    <Column field='role' header='Role'></Column>
                    <Column body={actionBodyTemplate} header="Actions"></Column>
                </DataTable>
            </div>
            <div className='userTabinfo'>*Deleting a user will remove the user from your account, they will still be able to login to the GeoFli Dashboard, they will not be able to see any existing campaigns.</div>
        </div>
    )
}

const RegisteredUsers = () => {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(3);
    const data = [
        { name: 'Name Lastname', email: 'info@domain.com', role: '' },
        { name: 'Name Lastname', email: 'email@domain.com', role: '' },
        { name: 'Name Lastname', email: 'josh@domain.com', role: '' },
        { name: 'Name Lastname', email: 'info@domain.com', role: '' },
        { name: 'Name Lastname', email: 'email@domain.com', role: '' },
        { name: 'Name Lastname', email: 'josh@domain.com', role: '' },
        { name: 'Name Lastname', email: 'info@domain.com', role: '' },
        { name: 'Name Lastname', email: 'email@domain.com', role: '' },
        { name: 'Name Lastname', email: 'josh@domain.com', role: '' },
    ]

    const actionBodyTemplate = () => {
        return (
            <span >
                <button><img src="images/edit-3.png" /></button>
                <button><img src="images/delete-3.png" /></button>
            </span>
        )
    }

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 3, value: 3 },
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const onCustomPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    }

    return <View {...{ data, actionBodyTemplate, first, rows, paginatorTemplate, onCustomPage }} />
}

export default RegisteredUsers;